module.exports = __webpack_public_path__ + "img/1549668432.51deef6d.jpg";